import React, { useState } from "react";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import {
  AiOutlineDashboard,
  AiOutlineShoppingCart,
  AiOutlineUser,
  AiOutlineBgColors,
  AiOutlineLogout,
} from "react-icons/ai";

import { RiCouponLine } from "react-icons/ri";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link } from "react-router-dom";
import { Outlet } from "react-router-dom";
import { ImBlog } from "react-icons/im";
import { RiAdvertisementLine } from "react-icons/ri";
import { SiCoinmarketcap } from "react-icons/si";
import { FaClipboardList, FaBloggerB } from "react-icons/fa";
import { SiBrandfolder } from "react-icons/si";
import { BiCategoryAlt } from "react-icons/bi";
import { TbCategoryPlus } from "react-icons/tb";
import { IoPricetagSharp } from "react-icons/io5";
import { ImPriceTags } from "react-icons/im";
import { Layout, Menu, theme } from "antd";
import { useNavigate } from "react-router-dom";
const { Header, Sider, Content } = Layout;
const MainLayout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  const navigate = useNavigate();
  return (
    <Layout /* onContextMenu={(e) => e.preventDefault()} */>
      <Sider trigger={null} collapsible collapsed={collapsed}>
        <div className="mt-4">
          <h2 className="">
            <span className="text-xl pl-6  text-white bg-gray-900">Admin </span>
          </h2>
        </div>
        <Menu
          theme="dark"
          mode="inline"
          defaultSelectedKeys={[""]}
          onClick={({ key }) => {
            if (key === "signout") {
              localStorage.clear();
              window.location.reload();
            } else {
              navigate(key);
            }
          }}
          items={[
            {
              key: "",
              icon: <AiOutlineDashboard className="fs-4" />,
              label: "Dashboard",
            },
            {
              key: "customers",
              icon: <AiOutlineUser className="fs-4" />,
              label: "Customers",
            },
            {
              key: "Catalog",
              icon: <AiOutlineShoppingCart className="fs-4" />,
              label: "Catalog",
              children: [
                {
                  key: "product",
                  icon: <AiOutlineShoppingCart className="fs-4" />,
                  label: "Add Product",
                },
                {
                  key: "list-product",
                  icon: <AiOutlineShoppingCart className="fs-4" />,
                  label: "Product List",
                },
                {
                  key: "Add-Store",
                  icon: <AiOutlineShoppingCart className="fs-4" />,
                  label: "Add store",
                },
                {
                  key: "list-Store",
                  icon: <AiOutlineShoppingCart className="fs-4" />,
                  label: "Store List",
                },
                {
                  key: "brand",
                  icon: <SiBrandfolder className="fs-4" />,
                  label: "Brand",
                },
                {
                  key: "list-brand",
                  icon: <SiBrandfolder className="fs-4" />,
                  label: "Brand List ",
                },
                {
                  key: "category",
                  icon: <BiCategoryAlt className="fs-4" />,
                  label: "Category",
                },
                {
                  key: "list-category",
                  icon: <BiCategoryAlt className="fs-4" />,
                  label: "Category List",
                },
                {
                  key: "subcategory",
                  icon: <TbCategoryPlus className="fs-4" />,
                  label: "Subcategory",
                },
                {
                  key: "list-subcategory",
                  icon: <TbCategoryPlus className="fs-4" />,
                  label: "subcategory List",
                },
                {
                  key: "tags",
                  icon: <IoPricetagSharp className="fs-4" />,
                  label: "tags",
                },
                {
                  key: "list-tag",
                  icon: <ImPriceTags className="fs-4" />,
                  label: "Tag List",
                },
                {
                  key: "sizes",
                  icon: <IoPricetagSharp className="fs-4" />,
                  label: "Sizes",
                },
                {
                  key: "list-size",
                  icon: <ImPriceTags className="fs-4" />,
                  label: "Size List",
                },
                {
                  key: "color",
                  icon: <AiOutlineBgColors className="fs-4" />,
                  label: "Color",
                },
                {
                  key: "list-color",
                  icon: <AiOutlineBgColors className="fs-4" />,
                  label: "Color List",
                },
              ],
            },
            {
              key: "orders",
              icon: <FaClipboardList className="fs-4" />,
              label: "Orders",
            },
            {
              key: "marketing",
              icon: <SiCoinmarketcap className="fs-4" />,
              label: "Marketing",
              children: [
                {
                  key: "coupon",
                  icon: <ImBlog className="fs-4" />,
                  label: "Add Coupon",
                },
                {
                  key: "coupon-list",
                  icon: <RiCouponLine className="fs-4" />,
                  label: "Coupon List",
                },
              ],
            },
            {
              key: "blogs",
              icon: <RiAdvertisementLine className="fs-4" />,
              label: "Ads",
              children: [
                {
                  key: "blog",
                  icon: <RiAdvertisementLine className="fs-4" />,
                  label: "Post Ads",
                },
                {
                  key: "blog-list",
                  icon: <FaBloggerB className="fs-4" />,
                  label: "Ad Lists",
                },
                {
                  key: "blog-category",
                  icon: <RiAdvertisementLine className="fs-4" />,
                  label: "Add Ads Category",
                },
                {
                  key: "blog-category-list",
                  icon: <FaBloggerB className="fs-4" />,
                  label: "Ads Category List",
                },
                {
                  key: "blogSubcategory",
                  icon: <TbCategoryPlus className="fs-4" />,
                  label: "Add Ads Subcategory",
                },
                {
                  key: "blog-subcategory-list",
                  icon: <TbCategoryPlus className="fs-4" />,
                  label: "Ads subcategory List",
                },
              ],
            },
            {
              key: "enquiries",
              icon: <FaClipboardList className="fs-4" />,
              label: "FAQ",
            },
            {
              key: "Delivery",
              icon: <AiOutlineUser className="fs-4" />,
              label: "Delivery",
              children: [
                {
                  key: "deliveryboylist",
                  icon: <RiCouponLine className="fs-4" />,
                  label: "Delivery-boy-list",
                },
                {
                  key: "adminOrderManagement",
                  icon: <RiCouponLine className="fs-4" />,
                  label: "Assign order ",
                },
              ],
            },
            {
              key: "signout",
              icon: <AiOutlineLogout className="fs-4" />,
              label: "Sign Out",
            },
          ]}
        />
      </Sider>
      <Layout className="site-layout">
        <Header
          className="d-flex justify-content-between ps-1 pe-5"
          style={{
            padding: 0,
            background: colorBgContainer,
          }}
        >
          {React.createElement(
            collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
            {
              className: "trigger",
              onClick: () => setCollapsed(!collapsed),
            }
          )}
          <div className="d-flex gap-4 align-items-center">
            <div className="d-flex gap-3 align-items-center dropdown">
              <div>
                <img
                  width={32}
                  height={32}
                  src="https://cdn1.vectorstock.com/i/1000x1000/11/15/man-with-the-inscription-admin-icon-color-outline-vector-39981115.jpg"
                  alt=""
                />
              </div>
              <div
                role="button"
                id="dropdownMenuLink"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <h5 className="mb-0">Eliyas</h5>
                <p className="mb-0">wub fashions</p>
              </div>
              <div className="dropdown-menu" aria-labelledby="dropdownMenuLink">
                <li>
                  <Link
                    className="dropdown-item py-1 mb-1"
                    style={{ height: "auto", lineHeight: "20px" }}
                    to="/"
                  >
                    View Profile
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item py-1 mb-1"
                    style={{ height: "auto", lineHeight: "20px" }}
                    to="/"
                  >
                    Signout
                  </Link>
                </li>
              </div>
            </div>
          </div>
        </Header>
        <Content
          style={{
            margin: "24px 16px",
            padding: 24,
            minHeight: 280,
            background: colorBgContainer,
          }}
        >
          <ToastContainer
            position="top-right"
            autoClose={250}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            theme="light"
          />
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};
export default MainLayout;
